import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { Paths } from "../../../paths";
import { EntLivestockTradeActivityFilter } from "../../../models/filters/organic/livestockTradeActivityFilter";
import { EntLivestockTradeActivity } from "../../../models/organic/livestockTradeActivity";

export const livestockTradeActivityApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getLivestockTradeActivityListAll: builder.query<ResponseDataGet<EntLivestockTradeActivity>, EntLivestockTradeActivityFilter>({
	  query: (filter) => ({
		url: `${ Paths.organic.livestockTradeActivity }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getLivestockTradeActivityById: builder.query<ResponseDataTest<EntLivestockTradeActivity>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.livestockTradeActivity }/${ id }`,
		method: 'GET'
	  })
	}),
	addLivestockTradeActivity: builder.mutation<ResponseDataTest<EntLivestockTradeActivity>, EntLivestockTradeActivity>({
	  query: (body) => ({
		url: `${ Paths.organic.livestockTradeActivity }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editLivestockTradeActivity: builder.mutation<ResponseDataTest<EntLivestockTradeActivity>, EntLivestockTradeActivity>({
	  query: (body) => ({
		url: `${ Paths.organic.livestockTradeActivity }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteLivestockTradeActivity: builder.mutation<ResponseDataTest<EntLivestockTradeActivity>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.livestockTradeActivity }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useGetLivestockTradeActivityListAllQuery,
  useGetLivestockTradeActivityByIdQuery,
  useAddLivestockTradeActivityMutation,
  useEditLivestockTradeActivityMutation,
  useDeleteLivestockTradeActivityMutation,
  useLazyGetLivestockTradeActivityListAllQuery
} = livestockTradeActivityApi;
